// 日志工具类

import storage from './LocalStorageManager';
import { isExtensionEnvironment } from './extensionUtils';

// 适应扩展环境的环境判断
const getEnvironment = () => {
  if (isExtensionEnvironment()) {
    return 'production';
  }
  // 方法1: 检查 process.env（如果可用）
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  
  // 方法2: 检查 window 对象中的环境变量（扩展环境）
  if (typeof window !== 'undefined' && window.NODE_ENV) {
    return window.NODE_ENV;
  }
  
  // 方法3: 根据 URL 判断环境
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    const port = window.location.port;
    
    // 检查是否在本地开发环境
    if ((hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0')) {
      return 'development';
    }
    
    // 检查常见的开发端口
    if (port === '3000' || port === '3001' || port === '8080' || port === '8000') {
      return 'development';
    }
  }
  
  // 方法4: 检查是否有开发工具特征
  if (typeof window !== 'undefined') {
    // 检查是否有 React DevTools
    if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
      return 'development';
    }
    
    // 检查是否有 Redux DevTools
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
      return 'development';
    }
  }
  
  return 'production';
};

const getLogsEnabled = () => {
  // 方法1: 检查 process.env（如果可用）
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_ENABLE_LOGS) {
    return process.env.REACT_APP_ENABLE_LOGS === 'true';
  }
  
  // 方法2: 检查 window 对象中的环境变量（扩展环境）
  if (typeof window !== 'undefined' && window.REACT_APP_ENABLE_LOGS) {
    return window.REACT_APP_ENABLE_LOGS === 'true';
  }
  
  // 方法3: 检查 storage 中的设置
  const enableLogs = storage.getItem('enableLogs');
  if (enableLogs !== null) {
    return enableLogs === 'true';
  }
  
  return false;
};

const isDevelopment = getEnvironment() === 'development';
const isLogsEnabled = getLogsEnabled();

class Logger {
  constructor(prefix = '') {
    this.prefix = prefix;
  }

  _formatMessage(message) {
    return this.prefix ? `${this.prefix} ${message}` : message;
  }

  _shouldLog() {
    // 在开发环境下始终启用日志
    // 在生产环境下根据REACT_APP_ENABLE_LOGS配置决定
    return isDevelopment || isLogsEnabled;
  }

  log(...args) {
    if (this._shouldLog()) {
      console.log(this._formatMessage(args[0]), ...args.slice(1));
    }
  }

  info(...args) {
    if (this._shouldLog()) {
      console.info(this._formatMessage(args[0]), ...args.slice(1));
    }
  }

  warn(...args) {
    if (this._shouldLog()) {
      console.warn(this._formatMessage(args[0]), ...args.slice(1));
    }
  }

  error(...args) {
    if (this._shouldLog()) {
      console.error(this._formatMessage(args[0]), ...args.slice(1));
    }
  }

  // 创建一个新的Logger实例，带有指定的前缀
  withPrefix(prefix) {
    return new Logger(`[${prefix}]`);
  }
}

// 导出默认实例
export default new Logger();

// 导出类，允许创建自定义实例
export { Logger }; 